import React from 'react';
import { Layout } from 'antd';
import { Navigate, Route, Routes } from 'react-router';
import { useSelector } from 'react-redux';

import Header from './components/header';
import Footer from './components/footer';
import { selectAuthenticated } from './data/slices/auth';
import Home from './scenes/home';
import NotFound from './scenes/not-found';
import Settings from './scenes/settings';
import LoadTest from './scenes/load-test';
import Forbidden from './scenes/forbidden';
import MonitoredApplications from './scenes/monitored-applications';

export const App: React.FunctionComponent = () => {
  const authenticated = useSelector(selectAuthenticated);

  return (
    <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
      {authenticated ? (
        <Layout style={{ flex: 1 }}>
          <Header renderMenu />
          <div style={{ display: 'flex', flex: 1, padding: 24, backgroundColor: '#e9e9e9', overflow: 'auto' }}>
            <Layout.Content>
              <div
                style={{
                  backgroundColor: 'white',
                  flex: 1,
                  display: 'flex',
                  padding: 24,
                  flexDirection: 'column',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Routes>
                  <Route path="/" element={<Navigate to="/home" replace />} />
                  <Route path="/home" element={<Home />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/load-test" element={<LoadTest />} />
                  <Route path="/monitored-applications" element={<MonitoredApplications />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </div>
            </Layout.Content>
          </div>
          <Footer />
        </Layout>
      ) : (
        <Routes>
          <Route path="/:section" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Forbidden />} />
        </Routes>
      )}
    </div>
  );
};
